import { render, staticRenderFns } from "./BlockContact.vue?vue&type=template&id=704be492&scoped=true&"
import script from "./BlockContact.vue?vue&type=script&lang=js&"
export * from "./BlockContact.vue?vue&type=script&lang=js&"
import style0 from "./BlockContact.vue?vue&type=style&index=0&id=704be492&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704be492",
  null
  
)

export default component.exports